// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__3LtlG","list":"News_list__3Pawt"};